var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16336",
    "data-name": "Group 16336",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    width: 38.991,
    height: 39,
    transform: "translate(0.009)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mortarboard",
    transform: "translate(0 3.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8245",
    "data-name": "Path 8245",
    d: "M422.264,192.224V180.612l-2.187.729v10.882a3.442,3.442,0,0,0-2.343,3.257v5.857a1.094,1.094,0,0,0,1.094,1.094h4.686a1.094,1.094,0,0,0,1.094-1.094v-5.857A3.442,3.442,0,0,0,422.264,192.224Z",
    transform: "translate(-386.432 -169.855)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8246",
    "data-name": "Path 8246",
    d: "M107.384,205.567,96.4,202.034v7.449a1.075,1.075,0,0,0,.332.773,17.012,17.012,0,0,0,23.454,0,1.075,1.075,0,0,0,.332-.773v-7.449l-10.984,3.533A3.518,3.518,0,0,1,107.384,205.567Z",
    transform: "translate(-89.371 -189.69)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8247",
    "data-name": "Path 8247",
    d: "M19.088,46.037a1.141,1.141,0,0,0,.354-.056l17.969-5.857a1.086,1.086,0,0,0,0-2.075L19.442,32.191a1.144,1.144,0,0,0-.707,0L.765,38.049a1.086,1.086,0,0,0,0,2.075l17.969,5.857a1.141,1.141,0,0,0,.354.056Z",
    transform: "translate(0 -32.135)",
    fill: "#f9b316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy1);
export default __webpack_public_path__ + "static/media/why1.0c951805c18a8051cbc560372ffa88c6.svg";
export { ForwardRef as ReactComponent };